module.exports = __webpack_public_path__ + "972c8d050a3330a614275ea346ec4c44.pdf";